<ms-loading-indicator />
@if (!hidden) {
    @if (!parent) {
        <ms-widget-header
            [ngClass]="{ 'clickable-widget-header': !!headerChevronLink }"
            [title]="title"
            [titleIcon]="titleIcon"
            [linkConfig]="headerLinkConfig"
            [sportId]="titleData?.sportId"
            [leagueId]="titleData?.id"
            [fallbackIcon]="titleData?.icon"
            (click)="headerNavigationHandler()">
            @if (headerChevronLink) {
                <span class="header-navigation-chevron">
                    <vn-icon name="theme-right" size="14" />
                </span>
            }
        </ms-widget-header>
    }

    @if (showPrimaryNavigation) {
        @if (showPrimaryNavAsPill) {
            <ms-widget-pill [pills]="primaryNavigation" (select)="primaryNavigationSelected($event)" />
        } @else {
            <ms-widget-tab-bar [tabs]="primaryNavigation" [stretch]="stretchTab" (select)="primaryNavigationSelected($event)" />
        }
    }

    @if (secondaryNavigation?.length) {
        <ms-widget-pill [pills]="secondaryNavigation" (select)="secondaryNavigationSelected()" />
    }

    @if (grid | async; as gridModel) {
        <ms-grid
            [model]="gridModel"
            [tracking]="tracking"
            [hideMarketSwitcher]="hideMarketSwitcher"
            [hideTitle]="hideGridTitle"
            [iconTemplate]="primaryActiveTab?.group?.type === groupTypeCompetition ? header : undefined"
            [gridHeaderOverride]="gridHeaderOverride"
            (eventClick)="eventClicked($event)" />
    } @else {
        <ms-error severity="info" [message]="sitecore.event.ErrNoEventsPerSport" [links]="false" />
    }

    @if (link && linkTitle) {
        <div class="grid-footer">
            <ms-item [count]="linkCount" [href]="link" [tracking]="undefined" (click)="linkClick()"
                ><span item-title [innerHtml]="linkTitle | msTrust: 'html'"></span>
            </ms-item>
        </div>
    }

    @if (hasMore) {
        <div class="grid-footer show-more" (click)="loadMore()">
            <div [class.spinner-img]="moreLoading">{{ showMoreMessage }}</div>
            @if (!moreLoading) {
                <vn-icon name="theme-down" size="12" />
            }
        </div>
    }
}

<ng-template #header>
    @if (primaryActiveTab) {
        <ms-competition-logo
            class="sport-icon"
            [sportId]="primaryActiveTab.sportId"
            [leagueId]="primaryActiveTab.itemId"
            [fallbackIcon]="primaryActiveTab.icon"
            [isLogoOverrideEnabled]="true" />
        <span class="sport-name">{{ primaryActiveTab.title }}</span>
    }
</ng-template>
